import React, { useCallback, useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Checkbox, Grid } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import LoadingDialog from "../../../components/Common/LoadingDialog";
import Notification from "../../../components/Common/Notification";
import SearchBar from "../../../components/Common/Searchbar";
import Table from "../../../components/Common/Table";
import TablePageControl from "../../../components/Common/TablePageControl";
import CustomButton from "../../../components/Form/CustomButton";
import CustomIconButton from "../../../components/Form/CustomIconButton";
import RenderPopOverButton from "../../../components/Form/RenderPopOverButton.js";
import Helpers from "../../../helpers/helpers";
import { deleteRole, exportRole, getRole, resetRoleAttachmentState, resetRoleState } from "../../../store/role/action";
import "../setting.css";
import DeleteModal from "../../../components/Common/DeleteModal.js";
import { getGeneral, verify_admin } from "../../../store/actions.js";


const RolesAndPermissions = ({ roleListing, exportRoleDocument, userPermission, delRoleArry }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate();

  const [loading, setIsLoading] = useState(false);
  const [values, setFormValues] = useState({ status: '' });
  const [page, setPage] = useState("1");
  const [length, setLength] = useState("50");
  const [keyword, setSearch] = useState("");
  const [sort, setSorted] = useState("asc");
  const [sort_by, setSortBy] = useState("id");
  const [selectedRow, setSelectedRow] = useState([]);
  const [checkedAll, setCheckedAll] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [notification, setNotification] = useState({
    open: false,
    msg: "",
    type: "success",
  });
  const [creatable, setCreatable] = useState(false);
  const [editable, setEditable] = useState(false);
  const [deletable, setDeletable] = useState(false);
  const [exportable, setExportable] = useState(false);
  const searchRef = useRef(keyword);

  useEffect(() => {
    if (userPermission?.length > 0) {
      userPermission?.includes("create-setting") && setCreatable(true);
      userPermission?.includes("edit-setting") && setEditable(true);
      userPermission?.includes("delete-setting") && setDeletable(true);
      userPermission?.includes("export-setting") && setExportable(true);
      !userPermission?.includes("view-setting") && navigate('/not-authorized');
    }
  }, [userPermission])

  useEffect(() => {
    searchRef.current = keyword;
  }, [keyword]);

  useEffect(() => {
    dispatch(resetRoleState());
  }, []);

  useEffect(() => {
    initData();
  }, [page, length, sort, sort_by]);

  useEffect(() => {
    if (exportRoleDocument?.code === 'success' && exportRoleDocument?.excel_base64) {
      Helpers.handleDownloadExcelFile(exportRoleDocument.excel_base64, 'role_listing');
      dispatch(resetRoleAttachmentState());
    }
    setIsLoading(false);
  }, [exportRoleDocument])

  useEffect(() => {
    if (delRoleArry?.code === "success") {
      setDeleteOpen(false);
      setNotification({
        open: true,
        msg: "Delete Successfully",
        type: "success",
      });
      dispatch(resetRoleState());
      dispatch(getGeneral());
      dispatch(verify_admin());

      initData();
    }
    setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delRoleArry]);

  const delRole = () => {
    if (selectedRow?.id) {
      setIsLoading(true);
      dispatch(deleteRole({ id: selectedRow?.id }))
    }
  }

  const initData = () => {
    let payload = {
      length: length,
      page: page,
      sortOrder: sort,
      sort: sort_by,
      search: searchRef.current
    }
    dispatch(getRole(payload));
  }

  const header = [
    {
      Header: "Role name ",
      columnID: "id",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            <div style={{ paddingRight: "5px" }}>{cellProps?.display_name || '-'}</div>
          </React.Fragment>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Description",
      columnID: "description",
      accessor: "description",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "No. of people",
      columnID: "user_count",
      accessor: "user_count",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Action",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            {editable && <Link to={`/edit-role/` + (cellProps.id)} >
              <CustomIconButton
                iconName={'ri-pencil-line'}
                onClick={() => ''}
              />
            </Link>}
            {deletable &&
              <RenderPopOverButton
                items={[{
                  iconName: 'ri-delete-bin-line',
                  label: 'Delete',
                  color: '#44d62c',
                  permission: deletable,
                  onClick: () => { setSelectedRow(cellProps); setDeleteOpen(true) }
                }]} />
            }
          </React.Fragment >
        )
      },
      position: 'sticky',
      disableFilters: true,
      filterable: false,
    }
  ]

  const handleExport = () => {
    setIsLoading(true);
    let filter = {
      search: keyword
    }
    Object.keys(filter).forEach(key => {
      if (!filter[key] || filter[key] === 'all') {
        delete filter[key];
      }
    });
    dispatch(exportRole({
      sort: sort_by,
      sort_order: sort,
      filter: filter
    }));
  }

  const handleSearch = (text) => {
    setSearch(text);
    setTimeout(() => {
      if (text === searchRef.current) {
        setPage("1");
        initData();
      }
    }, Helpers.searchInterval);
  }

  const resetFilter = () => {
    setPage("1");
    handleSearch('');
  }

  const customToolsBar = () => {
    return (
      <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
        <Grid container item className="d-flex align-items-center" md={10} lg={10} xs={12} spacing={1}>
          <Grid item lg={5} md={5} xs={12}>
            <SearchBar
              value={keyword}
              setValue={(e) => handleSearch(e)}
            />
          </Grid>
          <Grid item lg={7} md={7} xs={12}>
            <CustomButton
              title={'Clear'}
              press={() => resetFilter()}
              height={32}
              backgroundColor={'transparent'}
              textColor={'#7BB9FA'}
            />
          </Grid>
        </Grid>

        {
          exportable &&
          <Grid item lg={2} md={2} sm={12} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }} alignItems={'center'}>
            <CustomButton
              title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
              press={() => handleExport()}
              height={32}
              borderRadius={15}
              borderStyle={"1px solid #babcbe"}
            />
          </Grid>
        }

      </Grid >
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <LoadingDialog open={loading || !roleListing?.data} />
        <Container fluid>
          <Notification notification={notification} setNotification={setNotification} />
          <Breadcrumb
            title="Roles"
            backRoute={'/settings'}
            breadcrumbItems={[{ title: "Settings", link: "/settings" },
            { title: "Roles", link: "#" },
            ]}
          >
            {creatable && <CustomButton
              title={<><i className="ri-add-line" style={{ marginRight: '5px' }} /> Add Role</>}
              press={() => navigate("/add-role")}
              height={40}
              backgroundColor={'#101010'}
              textColor={'white'}
            />}
          </Breadcrumb>
          {customToolsBar()}
          <Table
            header={header}
            data={roleListing?.data || []}
            pageSize={length}
            totalPage={roleListing?.last_page || 1}
            customToolsBar={true}
            sort={sort}
            setSorted={setSorted}
            sort_by={sort_by}
            setSortBy={setSortBy}
            checkedAll={checkedAll}
            setCheckedAll={setCheckedAll}
          />
          <TablePageControl
            length={length}
            setLength={setLength}
            page={page}
            setPage={setPage}
            totalPage={roleListing?.last_page || 1}
          />
        </Container>
        <DeleteModal
          open={deleteOpen}
          close={() => setDeleteOpen(false)}
          submit={() => delRole()}
          module={'role'}
        />
      </div>
    </React.Fragment >
  );
};

function mapStateToProps({ Role, Login }) {
  return {
    roleListing: Role.role,
    exportRoleDocument: Role.exportRole,
    userPermission: Login.permissionArry,
    delRoleArry: Role?.delRole,

  };
}

export default connect(mapStateToProps)(RolesAndPermissions);